import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { setTimeRemaining } from "../../store";

import Clock from '../../assets/images/Clock.png';

interface CountDownProps {
    onTimeUp: () => void;
    time_Left: number;
}

const CountDown: React.FC<CountDownProps> = ({ onTimeUp, time_Left }) => {

    const [timeLeft, setTimeLeft] = useState<number | null>(null); // Initialize from Redux
    const dispatch = useDispatch();

    useEffect(() => {
        if (time_Left) {
            setTimeLeft(time_Left);
        }
    }, [time_Left]);


    useEffect(() => {
        const timer = setInterval(() => {
            setTimeLeft((prevTime) => {
                if (prevTime !== null && prevTime > 1) {
                    return prevTime - 1;
                } else {
                    clearInterval(timer);
                    dispatch(setTimeRemaining(0));
                    onTimeUp();
                    return 0;
                }
            });
        }, 1000);
        return () => {
            clearInterval(timer);
        };
    }, [dispatch, onTimeUp]);

    useEffect(() => {
        if (typeof window !== "undefined") {
            const handleBeforeUnload = () => {
                dispatch(setTimeRemaining(timeLeft ?? 0));
            };
            window.addEventListener("beforeunload", handleBeforeUnload);
            return () => {
                window.removeEventListener("beforeunload", handleBeforeUnload);
            };
        }
    }, [timeLeft, dispatch]);

    const formatTime = (totalSeconds: number) => {
        const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, "0");
        const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(
            2,
            "0"
        );
        const seconds = String(totalSeconds % 60).padStart(2, "0");

        if (Number(hours) > 0) {
            return (
                <>
                    <div>
                        {hours}:{minutes}:{seconds} sec
                    </div>
                </>
            );
        } else {
            return (
                <>
                    <div className="timer-clock">
                        <span>
                            <img src={Clock} alt="clock" className="clock" />
                        </span>
                        {minutes}:{seconds}
                    </div>
                </>
            );
        }
    };

    if (timeLeft === null) return null;

    return (
        <div>
            <div
                style={{
                    color: timeLeft <= 60 ? "red" : "#ffffff",
                    fontSize: timeLeft >= 3600 ? "18px" : "20px",
                    margin: "0px",
                    padding: "0px"
                }}
            >
                {formatTime(timeLeft)}
            </div>
        </div>
    );
};


export default CountDown;
